import * as types from 'constants/action-types';
import * as api from 'api';

export const setCurrentAccount = (user) => ({
  type: types.SET_CURRENT_ACCOUNT,
  user,
});

export const setAuthInfo = (token) => {
  localStorage.setItem('kluwellJwt', token);
  api.setAuthHeader(token);
};

export const removeAuthInfo = () => {
  localStorage.removeItem('kluwellJwt');
  api.setAuthHeader(false);
};

export const fetchCurrentAccount = () => {
  api.setAuthHeader(localStorage.getItem('kluwellJwt'));
  return (dispatch) =>
    api.fetchCurrentAccount().then((response) => {
      dispatch(setCurrentAccount(response.record));
      return response;
    });
};

export const login = (payload) => (dispatch) =>
  api.login(payload).then((response) => {
    setAuthInfo(response.token);
    dispatch(setCurrentAccount(response.user));
    return response;
  });

export const logout = () => (dispatch) =>
  api.logout().then((response) => {
    removeAuthInfo();
    dispatch(setCurrentAccount());
    return response;
  });

export const updateProfile = (payload) => (dispatch) =>
  api
    .updateProfile(payload)
    .then((response) => {
      setAuthInfo(response.token);
      dispatch(setCurrentAccount(response.user));
      return response;
    })
    .catch((err) => {
      removeAuthInfo();
      return Promise.reject(err);
    });

export const fetchTotalReadingDates = () => (dispatch) =>
  api.fetchCurrentAccount().then(({record: {totalReadingDates}}) => {
    dispatch(setTotalReadingDates(totalReadingDates));
  });

export const setTotalReadingDates = (dates) => ({
  type: types.SET_TOTAL_READING_DATES,
  dates,
});
